import React, { useEffect } from "react";
import { ScrollMenu } from "react-horizontal-scrolling-menu";
// import Arrow from 'react-arrows'
import { Container, Grid, Paper } from "@material-ui/core";

// import { useNavigate } from 'react-router-dom'
import DeliveryCard from "../cards/DeliveryCard";

export function DeliveryList(props) {
  // const nav = useNavigate();
  const [items, setItems] = React.useState([]);
  // const [selected, setSelected] = React.useState([]);
  // const [position, setPosition] = React.useState(0);
  const text = {
    padding: "10px",
    margin: "0",
  };
  const div_style = {
    background: "white",
    margin: "0",
  };

  useEffect(() => {
    setItems(props.list);
  });
  // const isItemSelected = (id) => !!selected.find((el) => el === id);
  // const handleClick =
  //     (id) =>
  //         ({ getItemById, scrollToItem }) => {
  //             nav(`/delivery/${id}`);
  //         };
  return (
    <div style={div_style}>
      <h3 style={text}>What would you like to order?</h3>
      <ScrollMenu
        style={{
          display: "flex",
          justifyContent: "center",
          width: "fit-content",
        }}
      >
        {items.map((item) => (
          <Grid key={item._id} style={{ margin: "8px" }}>
            <DeliveryCard delivery={item} />
          </Grid>
        ))}
      </ScrollMenu>
    </div>
  );
}
